import React from "react";
import Banner from "../components/Banner";
import BackButton from "../components/BackButton";
import { useSearchParams, useNavigate } from "react-router-dom";
import { ReactComponent as DotsIcon } from "../inlineSvgs/dots.svg";
import { ReactComponent as IlusIcon } from "../inlineSvgs/ilus-mail.svg";
import { resendEmail, verifyEmail } from "../api";
import { showNotification } from "../config";

const VerifyEmailPaga = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const redirect = useNavigate();

  const email = localStorage.getItem("registerUserEmail");

  const sendAgain = async (data) => resendEmail(data);

  const sendVerifyToken = async (taken) => {
    await verifyEmail(taken);

    showNotification("Account created successfully", "success");
    redirect("/login");
  };

  return (
    <div className="VerifyEmailPaga">
      <Banner />
      <div className="verifySection">
        <div>
          <div className="title">Verify your account</div>
          <div className="sub-title">Ensure the security by verifying your email address.</div>
          <DotsIcon />
        </div>

        <div>
          <IlusIcon />
          <div className="description">
            We've sent a verification link to your registered email. Check your spam folder if you don't see it. To
            resend the link, ensure your email address is correct, in the previous step.
          </div>
        </div>

        <button onClick={() => sendAgain(email)} className="send-again">
          Send verified link again
        </button>

        <div>
          <button
            type="button"
            className="beauty-btn fill"
            disabled={!token}
            onClick={() => sendVerifyToken(token)}
          >
            Verify Email Address
          </button>
          <BackButton className="beauty-btn border">Go Back</BackButton>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPaga;
